__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "knowledge_search_ui_mfe_search";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@cocounsel/prometheus", "3.0.157", () => (Promise.all([__webpack_require__.e(669), __webpack_require__.e(266), __webpack_require__.e(935), __webpack_require__.e(925)]).then(() => (() => (__webpack_require__(5266))))));
			register("@datadog/browser-rum", "6.33.0", () => (Promise.all([__webpack_require__.e(337), __webpack_require__.e(432)]).then(() => (() => (__webpack_require__(337))))));
			register("@microsoft/signalr", "8.0.29", () => (Promise.all([__webpack_require__.e(723), __webpack_require__.e(379)]).then(() => (() => (__webpack_require__(9723))))));
			register("@openfeature/core", "1.12.0", () => (() => (__webpack_require__(6640))), 1);
			register("@openfeature/react-sdk", "1.4.1", () => (() => (__webpack_require__(4119))), 1);
			register("@openfeature/web-sdk", "1.10.0", () => (() => (__webpack_require__(360))), 1);
			register("@splitsoftware/openfeature-web-split-provider", "1.1.0", () => (__webpack_require__.e(764).then(() => (() => (__webpack_require__(3764))))));
			register("@splitsoftware/splitio-browserjs", "1.7.1", () => (__webpack_require__.e(111).then(() => (() => (__webpack_require__(2111))))));
			register("@tanstack/react-query", "5.104.1", () => (Promise.all([__webpack_require__.e(565), __webpack_require__.e(870)]).then(() => (() => (__webpack_require__(9565))))));
			register("axios", "1.20.0", () => (Promise.all([__webpack_require__.e(267), __webpack_require__.e(760)]).then(() => (() => (__webpack_require__(8267))))));
			register("dompurify", "3.4.16", () => (__webpack_require__.e(977).then(() => (() => (__webpack_require__(7977))))));
			register("i18next", "23.16.8", () => (Promise.all([__webpack_require__.e(978), __webpack_require__.e(305)]).then(() => (() => (__webpack_require__(4978))))));
			register("luxon", "3.7.2", () => (Promise.all([__webpack_require__.e(28), __webpack_require__.e(116)]).then(() => (() => (__webpack_require__(28))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(7950))), 1);
			register("react-i18next", "13.5.0", () => (__webpack_require__.e(68).then(() => (() => (__webpack_require__(687))))));
			register("react-pdf", "10.5.0", () => (Promise.all([__webpack_require__.e(806), __webpack_require__.e(998)]).then(() => (() => (__webpack_require__(8425))))));
			register("react-router", "7.18.4", () => (Promise.all([__webpack_require__.e(694), __webpack_require__.e(51)]).then(() => (() => (__webpack_require__(7694))))));
			register("react", "18.3.1", () => (() => (__webpack_require__(5043))), 1);
			register("web-vitals", "2.1.4", () => (__webpack_require__.e(453).then(() => (() => (__webpack_require__(6453))))));
			initExternal(7028);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};